import { styled } from '@mui/material/styles';

const Viewport = styled('div')`
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.9);
`;

export default Viewport;
